export default __webpack_public_path__ + "static/media/tiktok.e3ca4e67.png";